import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  TextField,
  Button,
  Typography,
  Divider,
  Tooltip,
  Box,
  Paper,
  Alert,
  Grid,
  Popover,
  CircularProgress, // Import CircularProgress
  useMediaQuery // Import useMediaQuery
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ConfigTable from './ConfigTable';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';

import ItemListConfigTable from './ItemListConfigTable';
import { saveConfiguration, fetchConfiguration, API_BASE_URL } from '../api'; // Import API function
import FileUploadSection from './FileUploadSection'; // adjust path if needed


// Validation schema using Yup
const configSchema = (existingMainFileName, existingListTemplate, existingClientLogo) => Yup.object().shape({
  //globalSetting: Yup.string().required('Global Setting is required'),

  // templateFile: Yup.mixed().nullable().test(
  //   'required-if-no-existing',
  //   'Receipt Template File is required',
  //   function (value) {
  //     if (existingMainFileName) {
  //       console.log('validation for templateFIle called');
  //       alert('returning existing file ');
  //       return existingMainFileName;
  //     } else {
  //       alert('returning value '+ value);
  //       return value;
  //     }

  //   }
  // ),
  // itemListTemplateFile: Yup.mixed().nullable().test(
  //   'required-if-no-existing-3',
  //   'Item List Template File is required',
  //   function (value) {
  //     if (existingListTemplate) {
  //       alert('returning existing file ');
  //       return existingListTemplate;
  //     } else {
  //       alert('returning value '+ value);
  //       return value;
  //     }

  //   }
  // ),

  // clientLogo: Yup.mixed().nullable().test(
  //   'required-if-no-existing-2',
  //   'Logo is required',
  //   function (value) {
  //     if (existingClientLogo) {
  //       alert('returning existing file ');
  //       return existingClientLogo;
  //     } else {
  //       alert('returning value '+ value);
  //       return value;
  //     }
  //   }
  // ),

  //itemListTemplateFile: Yup.mixed().nullable().required('Item List template File is required'),
  //clientLogo: Yup.mixed().nullable().required('Logo is required'),

  // templateFile: Yup.mixed().when(existingMainFileName,{
  //   is: null,
  //   then: () => Yup.mixed().nullable().required('Main File is required'),
  //   otherwise: () => Yup.mixed().nullable(),
  // }

  // ),
  tableData: Yup.array().of(
    Yup.object().shape({
      placeHolderText: Yup.string().required('placeHolderText is required'),
      dataType: Yup.string().required('Data Type is required'),
      correspondingTableColumnName: Yup.string().required('Table column is required'),
      file: Yup.mixed().when(['dataType', 'existingFileName'], {
        is: (dataType, existingFileName) => {
          //alert('value - '+value);
          return dataType == 'MultipartFile' && !existingFileName
        },
        then: () => Yup.mixed().required('Select product'),
        otherwise: () => Yup.mixed().nullable(),
      }),

      //file: Yup.mixed().required('required file')
      // filename:Yup.mixed()
      // .test(
      //   'FILE_SIZE',
      //   'File is required',
      //   value => {console.log('val'+value)},
      // ),
      // file: Yup.mixed().when("dataType", {
      //   is: (val) =>{
      //     console.log(val);
      //     return val === "MultipartFile";
      //   },
      //   then: (s) => {
      //     console.log('then part');
      //     return Yup.mixed().required('File is required when File Upload is selected');
      //   },
      //   otherwise: (s) => {
      //     console.log('otherwise part');
      //     return s;
      //   },
      // }),
      // file:Yup.mixed.when("dataType", (dataType, configSchema) => {
      //   if(dataType == 'MultipartFile')
      //     return configSchema.required("Must enter email address")
      //   return configSchema
      // })
      // file: Yup.mixed().required().test(
      //   'required-if-no-existing-3',
      //   'File is required when File Upload is selected',
      //   function (context) {
      //     console.log('this '+context);
      //     // if (existingFileName) {
      //     //   //alert('returning existing file ');
      //     //   console.log(existingFileName);
      //     //   return existingFileName;
      //     // } else {
      //     //   //alert('returning value '+ value);
      //     //   return value;
      //     // }

      //   }
      // )
    })
    // .test({
    //   name: 'first-and-last',
    //   message: 'File is required',
    //   test: val => 
    //     val.every(
    //       ({ dataType,file }, index) => {
    //         if (dataType == 'MultipartFile') {
    //           console.log('required multipartfile')
    //           return !!file;
    //         }
    //         return true;
    //       }
    //     )
    // })
  )
  // .test({
  //     name: 'first-and-last',
  //     message: 'File is required',
  //     test: val => 
  //       val.every(
  //         ({ dataType,file }, index) => {
  //           alert(dataType);
  //           if (dataType == 'MultipartFile') {
  //             console.log('required multipartfile')
  //             return true;
  //           }
  //           return true;
  //         }
  //       )
  //   })
  ,
  // tableData1: Yup.array().of(
  //   Yup.object().shape({
  //     placeHolderText: Yup.string().required('placeHolderText is required'),
  //     description: Yup.string().required('description is required'),
  //     dataType: Yup.string().required('Data Type is required'),
  //     correspondingTableColumnName: Yup.string().required('Table column is required'),
  //     file: Yup.mixed().when('dataType', {
  //       is: 'MultipartFile',
  //       then: () => Yup.mixed().required('File is required when File Upload is selected'),
  //       otherwise: () => Yup.mixed().nullable(),
  //     }),
  //   })
  // ),
});

function ConfigPage() {
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [existingMainFileName, setExistingMainFileName] = useState(null);
  const [existingListTemplate, setExistingListTemplate] = useState(null);
  const [existingClientLogo, setExistingClientLogo] = useState(null);
  const [clientId, setClientId] = useState(null);
  //const [inputValue, setInputValue] = useState('');
  const [tableData, setConfigTableData] = useState([{ placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null,specialInstruction:'' }]);
  const [itemListConfigData, setItemListConfigData] = useState([{ placeHolderText: '', columnheader: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null }]);
  const [templateFile, setTemplateFile] = useState(null);
  const [itemListTemplateFile, setItemListTemplateFile] = useState(null);
  const [clientLogo, setClientLogo] = useState(null);
  const [templateFileError, setTemplateFileError] = useState('');
  const [itemListTemplateFileError, setItemListTemplateFileError] = useState('');
  const [clientLogoError, setClientLogoError] = useState('');

  // Loading state for initial fetch
  const [initialLoading, setInitialLoading] = useState(true); // New state
  const [parsingLoading, setParsingLoading] = useState(false); // New state for file parsing
  const messageRef = useRef(null); // Create a ref for the message area

  // const [tableData1, setTableData1] = useState([{ placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null }]);
  const initialValues = {
    //globalSetting: '',
    clientLogo: null,
    templateFile: null,
    itemListTemplateFile: null,
    tableData: tableData,
    itemListConfigData: itemListConfigData,
    clientId: null
    //  tableData1: tableData1
    // tableData1: [{ placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null }],
    //tableData: [{ placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null }],
  };

const [anchorEl, setAnchorEl] = useState(null); // State to manage the Popover anchor element

  // Open the popover when the user clicks on the Help icon
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the popover when the user clicks outside of it
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl); // Check if popover is open
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {

    const loadConfiguration = async () => {
      setInitialLoading(true); // Set initial loading to true

      try {
        const config = await fetchConfiguration();
        if (config) {

          // Assuming your backend returns data in the following structure:
          // { globalSetting: '...', mainFile: {name: '...', size: ...}, tableData1: [...], tableData2: [...] }

          // setValues({  // Use setValues from Formik
          //alert(JSON.stringify(config.data.tableData1[0].clientInfo));


          const modifiedData = (config.data.tableData1) ? config.data.tableData1.map((row) => {
            if (row.dataType == 'MultipartFile') {
              const existingColumnName = row.correspondingTableColumnName;
              row.correspondingTableColumnName = existingColumnName.substring(0, existingColumnName.indexOf('###'));
              row.existingFileName = existingColumnName.substring(existingColumnName.indexOf('###') + 3, existingColumnName.length);
              row.clientId = row.clientInfo.id;
              return row;
            } else {
              //     alert('non multipart');
              return row;
            }
          }) : null;


          setConfigTableData(modifiedData || [{ placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null, existingFileName: null,specialInstruction:'' }]);
          setItemListConfigData(config.data.itemListConfigData || [{ placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null }]);
          //});
          setExistingMainFileName(config.data.templateFileName ? config.data.templateFileName : null);
          setExistingListTemplate(config.data.itemListTemplateFile ? config.data.itemListTemplateFile : null);
          setExistingClientLogo(config.data.clientLogo ? config.data.clientLogo : null);
          setClientId(config.data.tableData1 ? config.data.tableData1[0].clientInfo.id : null);

        }
      } catch (error) {
        // setErrorMessage(`Failed to load config: ${error.message}`);
      } finally {
        setInitialLoading(false); // Set initial loading to false
      }
    };
    loadConfiguration();
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {


      if (!clientLogo && !existingClientLogo) {
        setClientLogoError('Please select a logo file before submitting.');
        setSubmitting(false); // Ensure submitting state is false

        return;
      }
      if (!templateFile && !existingMainFileName) {
        setTemplateFileError('Please select a receipt template file before submitting.');
        setSubmitting(false); // Ensure submitting state is false

        return;
      }

      if (!itemListTemplateFile && !existingListTemplate) {
        setItemListTemplateFileError('Please select an item list template file before submitting.');
        setSubmitting(false); // Ensure submitting state is false

        return;
      }

     // console.log('handle submit');
      // 1. Prepare Data Array
      // const data = values.tableData.map((row) => {
      //   return {
      //     data: {
      //       param1: row.name,
      //       param2: row.value,
      //       param3: row.selectChoice, // Store the select choice
      //       param4: row.secondSelectChoice, //Storing the second select choice
      //       param5: (row.selectChoice === 'File Upload' && row.file) ? 'static' : 'dynamic', // or 'dynamic'
      //     },
      //   };
      // });

      const data2 = values.tableData.map((row) => {
        const finalColumnName = row.dataType === 'MultipartFile' ? row.file ? row.correspondingTableColumnName + '###' + row.file.name : row.correspondingTableColumnName + '###' + row.existingFileName : row.correspondingTableColumnName;
        return {
          data: {
            placeHolderText: row.placeHolderText,
            specialInstruction: row.specialInstruction,
            dataType: row.dataType, // Store the select choice
            correspondingTableColumnName: row.dataType === 'MultipartFile' ? row.file ? row.correspondingTableColumnName + '###' + row.file.name : row.correspondingTableColumnName + '###' + row.existingFileName : row.correspondingTableColumnName,
            // correspondingTableColumnName: row.dataType === 'MultipartFile' ? row.correspondingTableColumnName + '###' + row.file.name : row.correspondingTableColumnName, //Storing the second select choice
            //   correspondingTableColumnName: finalColumnName , //Storing the second select choice
            description: row.description,
            contentType: 'dynamic'
          },
        };
      });

      // const data1 = values.tableData1.map((row) => {
      //   return {
      //     data: {
      //       placeHolderText: row.placeHolderText,
      //       dataType: row.dataType, // Store the select choice
      //       correspondingTableColumnName: row.dataType === 'MultipartFile' ? row.file.name : row.correspondingTableColumnName, //Storing the second select choice
      //       description: row.description,
      //       contentType: 'static'
      //     },
      //   };
      // });

      const itemListConfigData = values.itemListConfigData.map((row) => {
        return {
          data: {
            placeHolderText: row.placeHolderText,
            dataType: row.dataType, // Store the select choice
            correspondingTableColumnName: row.correspondingTableColumnName, //Storing the second select choice
            description: row.description,
            columnHeader: row.columnHeader,
            contentType: 'itemList'
          },
        };
      });

      const data = itemListConfigData.concat(data2);
      // const data = data2;
      // 2. Construct FormData
      const formData = new FormData();
      formData.append('data', JSON.stringify(data));
      formData.append('templateFile', templateFile);
      formData.append('itemListTemplateFile', itemListTemplateFile);
      formData.append('clientLogo', clientLogo);



      // 3. Append Files (Only if "File Upload" is selected)
      // console.log('before appending to form data');

      values.tableData.forEach((row) => {
        if (row.dataType === 'MultipartFile' && row.file) {
          formData.append('files', row.file, row.file.name); // Use file name
        }
      });
      // console.log('Form Data ' + JSON.stringify(formData));
      // 4. Make API call
      const saveResult = await saveConfiguration(formData); // Send FormData

      // console.log('Configuration save result:', saveResult);
      setSuccessMessage('Configuration saved successfully!');  // Set success message
      setErrorMessage(null);

      //  resetForm();
      setSubmitting(false);
      window.scrollTo(0, 0);

    } catch (error) {
      // console.error('Error saving configuration:', error);
      setErrorMessage(`Error saving configuration: ${error.message}`); // Set error message
      setSuccessMessage(null);
      setSubmitting(false);
      window.scrollTo(0, 0);

    }
  };

  const extractPlaceholderTexts = useCallback(async (file) => {
    // console.log('####' + file);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const fileContent = event.target.result;
          const regex = /\{\{([^}]+)\}\}/g; // Matches text within {{...}}
          const matches = [];
          let match;
          while ((match = regex.exec(fileContent)) !== null) {
            matches.push({ placeHolderText: match[0], description: '', dataType: '', correspondingTableColumnName: '', file: null,specialInstruction:'' });
          }
          resolve(matches);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsText(file);
    });
  }, []);

  const handleFileChange = async (inputComponentName, event) => {
    const file = event.currentTarget.files[0];
    if (inputComponentName === 'templateFile') {
      if (!file) {
        setTemplateFile(null);
        setTemplateFileError('Receipt Template is required');
        return;
      }
      setTemplateFile(file);
      setTemplateFileError('');
      // setFieldValue("templateFile", file);
    } else if (inputComponentName === 'itemListTemplateFile') {
      if (!file) {
        setItemListTemplateFile(null);
        setItemListTemplateFileError('Item List Template is required');
        return;
      }
      setItemListTemplateFile(file);
      setItemListTemplateFileError('');
      //  setFieldValue("itemListTemplateFile", file);
    } else if (inputComponentName === 'clientLogo') {
      if (!file) {
        setClientLogo(null);
        setClientLogoError('Logo is required');
        return;
      }
      setClientLogo(file);
      setClientLogoError('');
      //  setFieldValue("itemListTemplateFile", file);
    }
  };

  const handleParseFile = async (inputComponentName) => {
    // if (!mainFile) {
    //     setErrorMessage("Please select a file first.");
    //     return;
    // }m
    try {

      if (inputComponentName === 'templateFile') {
        // console.log('###tem' + templateFile);
        const extractedTexts = await extractPlaceholderTexts(templateFile);
        setConfigTableData(extractedTexts); // Update tableData1 with extracted names
      } else if (inputComponentName === 'itemListTemplateFile') {
        // console.log('#### item' + itemListTemplateFile);
        const extractedTexts = await extractPlaceholderTexts(itemListTemplateFile);
        setItemListConfigData(extractedTexts);
      }

    } catch (error) {
      // console.error("Error extracting placeholder texts:", error);
      setErrorMessage(`Error extracting data from file: ${error.message}`);
    }
  };


  const exportTableDataToCsv = (tableData, tableName) => {
    let csvContent = "data:text/csv;charset=utf-8,";
    const keysToExclude = ["id","clientId", "clientInfo", "createdDate", "contentType", "createdBy", "modifiedDate", "modifiedBy"];

    if (tableData && tableData.length > 0) {
      // csvContent += Object.keys(tableData[0]).join(",") + "\r\n";

      const newJson = Object.keys(tableData[0])
        .filter((key) => !keysToExclude.includes(key))
        .reduce((obj, key) => {
          obj[key] = tableData[0][key];
          return obj;
        }, {});

      csvContent += Object.keys(newJson).join(",") + "\r\n";
      tableData.forEach(item => {
        let row = "";

        const newItem = Object.keys(item)
          .filter((key) => !keysToExclude.includes(key))
          .reduce((obj, key) => {
            obj[key] = item[key];
            return obj;
          }, {});

        Object.values(newItem).forEach((value) => {
          //   alert(" key  export"+value+"   "+key);
          // Check if the value is a string before applying replace
          row += '"' + (typeof value === 'string' ? value.replace(/"/g, '""') : String(value)) + '",';
        });
        csvContent += row.slice(0, -1) + "\r\n";  // Remove the last comma
      });

      var link = document.createElement("a");
      link.setAttribute("href", encodeURI(csvContent));
      link.setAttribute("download", `tableData${tableName}.csv`);
      document.body.appendChild(link);

      link.click();
    }
  };

  const exportPayloadJson = (tableData, itemListConfigData, tableName) => {

    // console.log("itemListConfigData before export" + JSON.stringify(itemListConfigData));

    const keysToExclude = ["id","clientId", "clientInfo", "createdDate", "contentType", "createdBy", "modifiedDate", "modifiedBy"];
    const newArray = tableData.map(item => {
      const { ...newItem } = item;
      keysToExclude.forEach(key => delete newItem[key]);
      return newItem;
    });
    const payloadFormatJSON = {
      data: {
        "CSID": "MANDATORY TO ASSOCIATE WITH LOCATION, ADD DEFAULT STORE LOCATIONID HERE",
        "doubleWrapperAttribute1": "MANDATORY TO SHOW RECEIPT TOTAL### dataType:Double",
      }
    }
    newArray.map(item => {
      payloadFormatJSON['data'][item.correspondingTableColumnName] = item.placeHolderText + '### dataType:' + item.dataType + ' ### ' + item.description+' ### ' + item.specialInstruction;
    });


    // console.log('payload  format json' + JSON.stringify(payloadFormatJSON));

    const newItemListArray = itemListConfigData.map(item => {
      const { ...newItem } = item;
      keysToExclude.forEach(key => delete newItem[key]);
      return newItem;
    });

    // console.log('newItemListArray' + JSON.stringify(newItemListArray));
    const itemListJSON = {}
    newItemListArray.map(item => {
      itemListJSON[item.correspondingTableColumnName] = item.placeHolderText + '### dataType:' + item.dataType + ' ### ' + item.description;
    });

    // console.log('itemListJSON' + JSON.stringify(itemListJSON));
    const itemListJSONArray = [itemListJSON];
    payloadFormatJSON["data"]["itemList"] = itemListJSONArray;

    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify(payloadFormatJSON)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `tableData${tableName}.json`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportTableDataToJson = (tableData, tableName) => {
  //  console.log("table data before export" + JSON.stringify(tableData));

    const keysToExclude = ["id","clientId", "clientInfo", "createdDate", "contentType", "createdBy", "modifiedDate", "modifiedBy"];

    const newArray = tableData.map(item => {
      const { ...newItem } = item;
      keysToExclude.forEach(key => delete newItem[key]);
      return newItem;
    });

    // const payloadFormatJSON = {
    //   data:{
    //     "CSID":"SMVSGNR",
    //   }
    // }

    //   newArray.map(item => {
    //  //   let row = "";

    //     // const newItem = Object.keys(item)
    //     //   .filter((key) => !keysToExclude.includes(key))
    //     //   .reduce((obj, key) => {
    //     //     obj[key] = item[key];
    //     //     return obj;
    //     //   }, {});

    //    // item.map(obj  => {
    //       //   alert(" key  export"+value+"   "+key);
    //       // Check if the value is a string before applying replace
    //       payloadFormatJSON['data'][item.correspondingTableColumnName]=item.placeHolderText+'### dataType:'+item.dataType+' ### '+item.description;
    //      // row += '"' + (typeof value === 'string' ? value.replace(/"/g, '""') : String(value)) + '",';
    //    // });
    //     //csvContent += row.slice(0, -1) + "\r\n";  // Remove the last comma
    //   });


    //   console.log('payload  format json'+JSON.stringify(payloadFormatJSON));

    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify(newArray)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `tableData${tableName}.json`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  if (initialLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress /> {/* Show initial loading indicator */}
        <Typography variant="body1">Loading configuration...</Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3
        }}
      >
        <Typography variant="h5" gutterBottom>
          Receipt Configuration 
          <Button
              startIcon={<HelpOutlineIcon />}
              onClick={handleClick}
              disabled={tableData.length === 0}
            >
            </Button>
             
        </Typography>
              {/* Popover with instructions */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',  // Position the popover below the icon
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6">Important Points</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Here you can configure various settings related to the receipt layout and content.
            Below are the detailed instructions related to that:
            <ul>
              <li>You need to upload logo,receipt HTML template and Item List Template.</li>
              <li>Logo will be shown on the receipt listing screen and also on the Offer screen inside Handy Receipts Mobile Application.</li>
              <li>Receipt Template is an HTML Template with dynamic values in form place holder text surrounded by opening and closing curly braces. For ex. <code>{"{{CUSTOMER_NAME}}"}</code></li>
              <li>Item List Template is an HTML Template for dynamic list of items. It also has the same format i.e. place holder text surrounded by opening and closing curly braces.</li>
              <li>Receipt Template has to have <code>{"{{LIST_OF_ITEMS}}"}</code>. It will be replaced with content of Item List Template and looped through the number of times the items in the given receipt.</li>
              <li>Dynamic Placeholders' configuration section represents the metadata about place holder text from Receipt Template.</li>
              <li>Item List configuration section represents the metadata about Item List Template.</li>
              <li>Special Instruction is reserved for predefined instruction. It gives flexibility to choose column for designating particular column. For example for designating a column to use for association with user account using mobile number you can choose valu in it.</li>
              <li>You can use "Populate Dynamic Configuration Table" and "Populate Item List Configuration Table" to populate respective tables below. This will parse the HTML Template and populate place holder text Column.Note : It will be enabled only when file is uploaded newly.</li>
              <li>Use different Export buttons to export configuration in CSV and JSON format.</li>
              <li>Export Payload JSON button help you export configuration in format which is expected to be sent in receipt creating request.</li>
              <li>doubleWrapperAttribute1 column is reserved for Total Receipt Amount. This needs to store receipt total which will be used to show on receipt listing screen inside Handy Receipts Mobile Application</li>
              <li>Save your changes to apply them.Everytime you save, it will discard the previous changes and recreate new ones.</li>
            </ul>
          </Typography>
        </Box>
      </Popover>

       
        <Tooltip title="Download Payload JSON for current config">
          <span>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() => exportPayloadJson(tableData, itemListConfigData, 'payload')}
              disabled={tableData.length === 0}
            >
              Export Payload JSON
            </Button>
          </span>
        </Tooltip>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2} ref={messageRef}>
        {successMessage && (
          <Grid item xs={12}> {/* Full width on all screen sizes */}
            <Alert severity="success" icon={<CheckCircleIcon />}>{successMessage}</Alert>
          </Grid>
        )}
        {errorMessage && (
          <Grid item xs={12}>
            <Alert severity="error">{errorMessage}</Alert>
          </Grid>
        )}
      </Grid>

      <Formik
        initialValues={initialValues}
        validationSchema={configSchema(existingMainFileName, existingListTemplate, existingClientLogo)}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting, setValues }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {/* Upload section properly spaced below heading */}
                <FileUploadSection
                  templateFile={templateFile}
                  receiptTemplate={templateFile}
                  itemTemplate={itemListTemplateFile}
                  setTemplateFile={setTemplateFile}
                  templateFileError={templateFileError}
                  existingTemplateFileName={existingMainFileName}
                  existingTemplateFileUrl={`${API_BASE_URL}/files/${clientId}/${existingMainFileName}`}

                  itemListTemplateFile={itemListTemplateFile}
                  setItemListTemplateFile={setItemListTemplateFile}
                  itemListTemplateFileError={itemListTemplateFileError}
                  existingItemListTemplateFileName={existingListTemplate}
                  existingItemListTemplateFileUrl={`${API_BASE_URL}/files/${clientId}/${existingListTemplate}`}

                  logoFile={clientLogo}
                  setLogoFile={setClientLogo}
                  logoFileError={clientLogoError}
                  existingLogoFileName={existingClientLogo}
                  existingLogoFileUrl={`${API_BASE_URL}/files/${clientId}/${existingClientLogo}`}
                                    onParseReceiptTemplate={() => handleParseFile('templateFile')}
                  onParseItemTemplate={() => handleParseFile('itemListTemplateFile')}

                />
              </Grid>

              {/* Other config elements... */}
              <Grid item sx={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Dynamic Placeholders' configuration</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 1 }}>
                  <Button variant="outlined" size="small"
                    startIcon={<DownloadIcon />}
                    sx={{ marginRight: 1 }}
                    onClick={() => exportTableDataToCsv(tableData, "Table1")}>
                    Export to CSV
                  </Button>
                  <Button variant="outlined" size="small" startIcon={<DownloadIcon />} onClick={() => exportTableDataToJson(tableData, "Table1")}>
                    Export to JSON
                  </Button>
                </Box>
                <ConfigTable
                  tableData={values.tableData}
                  setTableData={setFieldValue}
                  errors={errors.tableData}
                  touched={touched.tableData}
                  tableKey="tableData"
                />
              </Grid>
              <Grid item xs={12}> {/* Table takes full width */}
                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Item List configuration</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 1 }}>
                  <Button variant="outlined" size="small" startIcon={<DownloadIcon />} onClick={() => exportTableDataToCsv(itemListConfigData, "Table2")}>
                    Export to CSV
                  </Button>
                  <Button variant="outlined" size="small" startIcon={<DownloadIcon />} onClick={() => exportTableDataToJson(itemListConfigData, "Table2")}>
                    Export to JSON
                  </Button>
                </Box>
                <ItemListConfigTable
                  tableData={values.itemListConfigData}
                  setTableData={setFieldValue}
                  errors={errors.itemListConfigData}
                  touched={touched.itemListConfigData}
                  tableKey="itemListConfigData"
                // otherTableData={values.tableData1}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 3 }}> {/* Full width with margin-top */}
                <Button variant="contained" color="primary" type="submit" disabled={isSubmitting}
                  sx={{ padding: '12px 20px', fontWeight: 'bold', mt: 2 }}
                >
                  {isSubmitting ? <CircularProgress size={24} color="inherit" /> : 'Save Configuration'} {/* Show spinner when submitting */}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Paper>
  );
}

export default ConfigPage;